import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";
import {
  GetCategoryMenuListURL,
  GetEditDishesProductURL,
  EditDishesProductURL,
  RemoveProductImage
} from "../../assets/api/BaseURL";
import LoadingModal from "../../loader/LoadingModal";
import Select from "react-select";
import Notification from "../other/Notification";
import { useToast } from "../../../context/ToastContext";

const EditProduct = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const productImageRef = useRef(null);
  const [token, setToken] = useState("");
  const [productID, setProductID] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [flag, setFlag] = useState(false);
  const [productImage, setProductImage] = useState("");
  const maxImageSize = 1024 * 1024;
  const maxImageWidth = 500;
  const maxImageHeight = 500;
  const [menuList, setMenuList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [product, setProduct] = useState({
    menu_id: "",
    name: "",
    price: "",
    proprice: "",
    tax: "",
    tax_type: "",
    status: true,
    picture: "",
    product_type: "",
    top_rated: false,
    best_seller: false,
    most_ordered: false,
    dine_in: false,
    delivery: false,
    pick_up: false,
    is_addon: false,
    is_foreign: false,
    feature: false,
    minQuantity: "1",
    preparation_time: "5",
    description: "",
    packaging_charges: "0",
    variant1: "",
    variant2: "",
    variant3: "",
    variant4: "",
    suggestion_price: "",
  });

  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleTagInputChange = (e) => {
    setInputValue(e.target.value);
    setError("");
    setSuccess("");
  };

  const handleInputKeyPress = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      setTags([...tags, inputValue.trim()]);
      setInputValue("");
      setError("");
      setSuccess("");
    }
  };

  const handleTagClick = (tagIndex) => {
    const newTags = [...tags];
    newTags.splice(tagIndex, 1);
    setTags(newTags);
    setError("");
    setSuccess("");
  };

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const isValidNumber = (value) => {
    return !isNaN(parseFloat(value)) && isFinite(value);
  };

  const handleDishesProductsClick = (e) => {
    e.preventDefault();
    navigate("/view_products");
  };

  const handleManageVariantClick = (e) => {
    e.preventDefault();
    navigate("/manage_variant");
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox") {
      setProduct((prevProduct) => ({
        ...prevProduct,
        [name]: checked,
      }));
      setError("");
      setSuccess("");
    } else if (type === "radio" && parseInt(value) === 3) {
      setProduct((prevProduct) => ({
        ...prevProduct,
        [name]: value,
        delivery: false,
        pick_up: false,
      }));
      setError("");
      setSuccess("");
    } else {
      setProduct((prevProduct) => ({
        ...prevProduct,
        [name]: value,
      }));
      setError("");
      setSuccess("");
    }
  };

  // Handle tax input change with precision fix
  const handleTaxChange = (e) => {
    let value = e.target.value;

    // Allow empty string
    if (value === "") {
      setProduct((prev) => ({ ...prev, tax: "" }));
      return;
    }

    // Parse the value
    let numValue = parseFloat(value);

    // Check if it's a valid number
    if (!isNaN(numValue)) {
      // Round to 2 decimal places to avoid floating point issues
      let roundedValue = Math.round(numValue * 100) / 100;

      // Ensure value is between 0 and 100
      if (roundedValue > 100) {
        roundedValue = 100;
      }
      if (roundedValue < 0) {
        roundedValue = 0;
      }

      // Format to ensure proper decimal places
      // This prevents 18 from becoming 17.9999999
      const formattedValue = roundedValue.toString();
      setProduct((prev) => ({ ...prev, tax: formattedValue }));
    } else {
      setProduct((prev) => ({ ...prev, tax: value }));
    }
  };

  const handleRemoveImg = async () => {
    setIsLoading(true);

    try {
      const response = await axios({
        method: "put",
        url: RemoveProductImage,
        data: { id: productID },
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 && response.data.message) {
        setError("");
        setSuccess(response.data.message);
        scrollToTop();
        setProductImage("");
        productImageRef.current.value = "";
        setFlag(!flag);
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        setError(error.response.data.message);
        setSuccess("");
        scrollToTop();
      } else {
        setError(error.message);
        setSuccess("");
        scrollToTop();
      }
      console.log(error);
    }
    setIsLoading(false);
  };

  const handleSelectMenu = (selectedOption) => {
    setSelectedMenu(selectedOption);
    setError("");
    setSuccess("");
  };

  function isImageSizeValid(file) {
    if (file && file.size) {
      return file.size <= maxImageSize;
    }
    return false;
  }

  function isImageDimensionsValid(file) {
    if (file) {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      return new Promise((resolve) => {
        image.onload = () => {
          const width = image.width;
          const height = image.height;

          const isValidDimensions =
            width <= maxImageWidth && height <= maxImageHeight;

          resolve(isValidDimensions);
        };
      });
    }

    return false;
  }

  const handleSaveProduct = async (e) => {
    e.preventDefault();

    // Format tax value before validation to ensure it's properly rounded
    let formattedTax = product.tax;
    // if (formattedTax && !isNaN(parseFloat(formattedTax))) {
    //   formattedTax = (Math.round(parseFloat(formattedTax) * 100) / 100).toString();
    // }

    if (selectedMenu === null) {
      setError("Menu/Category cannot be empty");
      setSuccess("");
      scrollToTop();
    } else if (product.name === "") {
      setError("Name cannot be empty");
      setSuccess("");
      scrollToTop();
    } else if (product.product_type === "") {
      setError("Item Type cannot be empty");
      setSuccess("");
      scrollToTop();
    } else if (product.preparation_time === "") {
      setError("Preparation Time  cannot be empty");
      setSuccess("");
      scrollToTop();
    } else if (product.price === "") {
      setError(" Price cannot be empty");
      setSuccess("");
      scrollToTop();
    } else if (!isValidNumber(product.price)) {
      setError("Please enter a valid  Price");
      setSuccess("");
      scrollToTop();
    } else if (product.proprice && !isValidNumber(product.proprice)) {
      setError("Please enter a valid Offer Price");
      setSuccess("");
      scrollToTop();
    } else if (product.proprice && parseFloat(product.proprice) <= 0) {
      setError("Offer Price should be greater than 0");
      setSuccess("");
      scrollToTop();
    } else if (
      product.proprice &&
      parseFloat(product.proprice) > parseFloat(product.price)
    ) {
      setError("Offer Price cannot be greater than Base Price");
      setSuccess("");
      scrollToTop();
    } else if (
      product?.tax === null ||
      product?.tax === undefined ||
      String(product.tax).trim() === ""
    ) {
      setError("Tax Rate cannot be empty");
    }
    else if (!/^\d+(\.\d+)?$/.test(product.tax)) {
      setError("Tax Rate must be a valid number");
      setSuccess("");
      scrollToTop();
    } else if (parseFloat(formattedTax) < 0 || parseFloat(formattedTax) > 100) {
      setError("Tax Rate must be between 0 and 100");
      setSuccess("");
      scrollToTop();
    } else if (product.tax_type === "") {
      setError("Tax Type cannot be empty");
      setSuccess("");
      scrollToTop();
    } else if (
      !product.dine_in &&
      !product.delivery &&
      !product.pick_up &&
      !product.is_addon
    ) {
      setError("Select atleast one service type");
      setSuccess("");
      scrollToTop();
    } else if ((product.minQuantity && !isValidNumber(product.minQuantity))) {
      setError("Please enter a valid Minimum Order Quantity");
      setSuccess("");
      scrollToTop();
    } else if (!(parseInt(product.minQuantity) > 0)) {
      setError("Please enter a valid Minimum Order Quantity");
      setSuccess("");
      scrollToTop();
    } else if (
      product.packaging_charges &&
      !isValidNumber(product.packaging_charges)
    ) {
      setError("Please enter a valid Packaging Fee");
      setSuccess("");
      scrollToTop();
    }
    else if (productImage && !isImageSizeValid(productImage)) {
      setError(`Image size cannot be greater than ${maxImageSize / 1024}kb`);
      productImageRef.current.value = "";
      setProductImage("");
      setSuccess("");
      scrollToTop();
    } else if (productImage && !(await isImageDimensionsValid(productImage))) {
      setError(
        `Image Dimensions cannot be greater than ${maxImageWidth}*${maxImageHeight}`
      );
      productImageRef.current.value = "";
      setProductImage("");
      setSuccess("");
      scrollToTop();
    } else {
      const dataToSend = new FormData();
      dataToSend.append("id", productID);
      dataToSend.append("menu_id", selectedMenu.value);
      dataToSend.append("name", product.name);
      dataToSend.append("price", product.price);
      dataToSend.append("proprice", product.proprice);
      // Send formatted tax value to API
      dataToSend.append("tax_percent", formattedTax);
      dataToSend.append("tax_type", product.tax_type);
      dataToSend.append("tags", tags.join(", "));
      dataToSend.append("status", product.status ? 1 : 0);
      dataToSend.append(
        "picture",
        productImage ? productImage : product.picture
      );
      dataToSend.append("product_type", product.product_type);
      dataToSend.append("top_rated", product.top_rated ? 1 : 0);
      dataToSend.append("best_seller", product.best_seller ? 1 : 0);
      dataToSend.append("most_ordered", product.most_ordered ? 1 : 0);
      dataToSend.append("dine_in_service", product.dine_in ? 1 : 0);
      dataToSend.append("delivery_service", product.delivery ? 1 : 0);
      dataToSend.append("pick_up_service", product.pick_up ? 1 : 0);
      dataToSend.append("is_addon", product.is_addon ? 1 : 0);
      dataToSend.append("is_foreign", product.is_foreign);
      dataToSend.append("min_order_quantity", product.minQuantity);
      dataToSend.append("feature", product.feature ? 1 : 0);
      dataToSend.append("preparation_time", product.preparation_time);
      dataToSend.append("description", product.description);
      dataToSend.append("packaging_charges", product.packaging_charges ? product.packaging_charges : 0);
      dataToSend.append("foreign_price", product.foreign_price ? product.foreign_price : 0);

      setIsLoading(true);
      try {
        const response = await axios({
          method: "put",
          url: EditDishesProductURL,
          data: dataToSend,
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200 && response.data.message) {
          setError("");
          setSuccess(response.data.message);
          scrollToTop();
          setProductImage("");
          productImageRef.current.value = "";
          setFlag(!flag);
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          setError(error.response.data.message);
          setSuccess("");
          scrollToTop();
        } else {
          setError(error.message);
          setSuccess("");
          scrollToTop();
        }
        console.log(error);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);

  useEffect(() => {
    if (localStorage.getItem("currencySymbol")) {
      setCurrencySymbol(localStorage.getItem("currencySymbol"));
    }
  }, []);

  useEffect(() => {
    setProductID(localStorage.getItem("productID"));
  }, [productID]);

  useEffect(() => {
    if (token) {
      async function getMenuList() {
        try {
          const response = await axios.get(GetCategoryMenuListURL, {
            headers: { authorization: `Bearer ${token}` },
          });

          if (response.status === 200 && response.data.data) {
            const modifiedData = response.data.data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setMenuList(modifiedData);
          }
        } catch (error) {
          if (error.response && error.response.data.message) {
            addToast("error", error.response.data.message);
          } else {
            addToast("error", error.message);
          }
          console.log(error);
        }
      }
      getMenuList();
    }
  }, [token, addToast]);

  useEffect(() => {
    if (token && productID) {
      async function getData() {
        setIsLoading(true);
        try {
          const response = await axios.get(
            GetEditDishesProductURL + `?id=${productID}`,
            {
              headers: { authorization: `Bearer ${token}` },
            }
          );

          if (response.status === 200 && response.data.data) {
            // Format tax value to ensure proper decimal places
            let taxValue = response.data.data.tax_percent;
            if (taxValue && !isNaN(parseFloat(taxValue))) {
              taxValue = (Math.round(parseFloat(taxValue) * 100) / 100).toString();
            }

            setProduct({
              menu_id: response.data.data.menu_id,
              name: response.data.data.product_name,
              price: response.data.data.price,
              proprice: response.data.data.proprice,
              tax: taxValue,
              tax_type: response.data.data.tax_type,
              status: response.data.data.status === 1 ? true : false,
              picture: response.data.data.picture,
              product_type: response.data.data.product_type,
              top_rated: response.data.data.top_rated === 1 ? true : false,
              best_seller: response.data.data.best_seller === 1 ? true : false,
              most_ordered: response.data.data.most_ordered === 1 ? true : false,
              dine_in: response.data.data.dine_in_service === 1 ? true : false,
              delivery: response.data.data.delivery_service === 1 ? true : false,
              pick_up: response.data.data.pick_up_service === 1 ? true : false,
              is_addon: response.data.data.is_addon === 1 ? true : false,
              is_foreign: response.data.data.is_foreign,
              feature: response.data.data.feature === 1 ? true : false,
              minQuantity: response.data.data.min_order_quantity,
              preparation_time: response.data.data.preparation_time,
              description: response.data.data.description,
              packaging_charges: response.data.data.packaging_charges,
              foreign_price: response.data.data.foreign_price || "",
              variant1: response.data.data.variant1 || "",
              variant2: response.data.data.variant2 || "",
              variant3: response.data.data.variant3 || "",
              variant4: response.data.data.variant4 || "",
              suggestion_price: response.data.data.suggestion_price || "",
            });
            setTags(
              response.data.data.product_tags
                ? response.data.data.product_tags.split(", ")
                : []
            );
          }
        } catch (error) {
          if (error.response && error.response.data.message) {
            addToast("error", error.response.data.message);
          } else {
            addToast("error", error.message);
          }
          console.log(error);
        }
        setIsLoading(false);
      }
      getData();
    }
  }, [token, productID, flag, addToast]);

  useEffect(() => {
    if (product.menu_id && menuList) {
      const menu = menuList.filter((item) => item.value === product.menu_id);
      setSelectedMenu(menu[0]);
    }
  }, [product.menu_id, menuList]);

  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                  {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="view_products" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="ukhd mb-3">Menu Items</h3>
                      <div className="row flex-grow">
                        <div className="col-12 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body">
                              <div className="d-sm-flex justify-content-between align-items-start mb-2">
                                <div className="vsalign">
                                  <h4 className="card-title card-title-dash">
                                    Edit Menu Item
                                  </h4>
                                </div>
                                <div className="vsalign">
                                  <span
                                    className="btn btn-danger mb-0 me-0"
                                    onClick={handleDishesProductsClick}
                                  >
                                    <i className="menu-icon mdi mdi-arrow-left vsalign"></i>
                                    Go Back
                                  </span>
                                </div>
                              </div>
                              <form className="forms-sample">
                                {error && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-danger">
                                    <div className="vsalign">{error}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setError("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {success && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-success">
                                    <div className="vsalign">{success}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSuccess("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <div className="row">
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label>Product Table</label>
                                      <div className="d-flex gap-3">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="is_foreign"
                                            id="indianRadio"
                                            value={0}
                                            checked={product.is_foreign === 0}
                                            onChange={(e) =>
                                              setProduct((prev) => ({
                                                ...prev,
                                                is_foreign: Number(e.target.value),
                                              }))
                                            }
                                          />
                                          <label className="form-check-label" htmlFor="indianRadio">
                                            Local
                                          </label>
                                        </div>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="is_foreign"
                                            id="foreignerRadio"
                                            value={1}
                                            checked={product.is_foreign === 1}
                                            onChange={(e) =>
                                              setProduct((prev) => ({
                                                ...prev,
                                                is_foreign: Number(e.target.value),
                                              }))
                                            }
                                          />
                                          <label className="form-check-label" htmlFor="foreignerRadio">
                                            International
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Menu/Category
                                        <span className="text-danger">*</span>
                                      </label>
                                      <Select
                                        options={menuList}
                                        value={selectedMenu}
                                        onChange={handleSelectMenu}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Name
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Product Name"
                                        name="name"
                                        value={product.name}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Item Type
                                        <span className="text-danger">*</span>
                                      </label>

                                      <div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="veg"
                                            name="product_type"
                                            value="0"
                                            checked={
                                              parseInt(product.product_type) ===
                                              0
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="veg"
                                          >
                                            Veg
                                          </label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="nonVeg"
                                            name="product_type"
                                            value="1"
                                            checked={
                                              parseInt(product.product_type) ===
                                              1
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="nonVeg"
                                          >
                                            Non-Veg
                                          </label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="egg"
                                            name="product_type"
                                            value="2"
                                            checked={
                                              parseInt(product.product_type) ===
                                              2
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="egg"
                                          >
                                            Egg
                                          </label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="alcohol"
                                            name="product_type"
                                            value="3"
                                            checked={
                                              parseInt(product.product_type) ===
                                              3
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="alcohol"
                                          >
                                            Alcohol
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Preparation Time(Minutes)
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="preparation_time"
                                        value={product.preparation_time}
                                        onChange={handleInputChange}
                                      >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                        <option value="25">25</option>
                                        <option value="30">30</option>
                                        <option value="35">35</option>
                                        <option value="40">40</option>
                                        <option value="45">45</option>
                                        <option value="50">50</option>
                                        <option value="55">55</option>
                                        <option value="60">60</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Price
                                        <span className="text-danger">*</span>
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Price"
                                          name="price"
                                          value={product.price}
                                          onChange={handleInputChange}
                                        />
                                        <span className="input-group-text">
                                          {currencySymbol}
                                        </span>
                                      </div>
                                      {product.suggestion_price && (
                                        <small className="text-success">Suggestion Price:  {currencySymbol} {product.suggestion_price}</small>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>Offer Price </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Offer Price"
                                          name="proprice"
                                          value={product.proprice}
                                          onChange={handleInputChange}
                                        />
                                        <span className="input-group-text">
                                          {currencySymbol}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Tax Rate(%)
                                        <span className="text-danger">*</span>
                                      </label>

                                      <div className="input-group">
                                        <input

                                          className="form-control"
                                          placeholder="Enter Tax Rate"
                                          name="tax"
                                          value={product.tax}
                                          onChange={handleTaxChange}
                                          min="0"
                                          max="100"
                                          step="0.01"
                                          onKeyDown={(e) => {
                                            if (e.key === '-' || e.key === 'e') {
                                              e.preventDefault();
                                            }
                                          }}
                                        />
                                        <span className="input-group-text">
                                          %
                                        </span>
                                      </div>




                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Tax Type
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="tax_type"
                                        value={product.tax_type}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          Select Tax Type
                                        </option>
                                        <option value="0">Exclude</option>
                                        <option value="1">Include</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group togglecss">
                                      <label>Status</label>
                                      <div
                                        className={`button r ${product.status ? "active" : ""
                                          }`}
                                        id="button-1"
                                      >
                                        <input
                                          type="checkbox"
                                          className="checkbox"
                                          name="status"
                                          checked={product.status}
                                          onChange={handleInputChange}
                                        />
                                        <div className="knobs"></div>
                                        <div className="layer"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Service Type
                                        <span className="text-danger">*</span>
                                      </label>
                                      <div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="dine_in"
                                            checked={product.dine_in}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Dine In
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="delivery"
                                            disabled={
                                              parseInt(product.product_type) ===
                                              3
                                            }
                                            checked={product.delivery}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Delivery
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="pick_up"
                                            disabled={
                                              parseInt(product.product_type) ===
                                              3
                                            }
                                            checked={product.pick_up}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Pick Up
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="is_addon"
                                            checked={product.is_addon}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Is Addon
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Minimum Order Quantity
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Minimum Order Quantity"
                                        name="minQuantity"
                                        value={product.minQuantity}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>Packaging Fee</label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Packaging Fee"
                                          name="packaging_charges"
                                          value={product.packaging_charges}
                                          onChange={handleInputChange}
                                        />
                                        <span className="input-group-text">
                                          {currencySymbol}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* <div className="col-12">
                                    <div className="form-group">
                                      <label>Tags</label>
                                      <div id="tags">
                                        {tags.map((tag, index) => (
                                          <span
                                            key={index}
                                            onClick={() =>
                                              handleTagClick(index)
                                            }
                                          >
                                            {tag}
                                          </span>
                                        ))}
                                        <input
                                          type="text"
                                          className=""
                                          value={inputValue}
                                          placeholder="Add a tag & hit Enter"
                                          onChange={handleTagInputChange}
                                          onKeyDown={handleInputKeyPress}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label>Description</label>
                                      <textarea
                                        className="form-control"
                                        placeholder="Enter Description"
                                        name="description"
                                        value={product.description}
                                        onChange={handleInputChange}
                                      ></textarea>
                                    </div>
                                  </div> */}
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-4">
                                        {product.picture ? (
                                          <img
                                            src={product.picture}
                                            alt="Product Img"
                                            style={{ width: "20%" }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                        <div className="form-group">
                                          <label>Item Image</label>
                                          <div style={{ display: "flex" }}>
                                            <div>
                                              <input
                                                style={{ minWidth: "300px" }}
                                                className="form-control"
                                                type="file"
                                                id="formFile"
                                                accept=".jpeg, .jpg, .png"
                                                ref={productImageRef}
                                                onChange={(e) =>
                                                  setProductImage(e.target.files[0])
                                                }
                                              />
                                              <p style={{ color: 'red' }}>Recommended size: 200 × 200 px
                                                <br />Maximum size: 1024 × 1024 px (up to 1 MB)
                                                <br />Supported formats: JPG, JPEG, PNG
                                                <br />This image is displayed on the QR ordering screen.</p>
                                            </div>
                                            {!product.picture?.includes("/img/noimage.png") ?
                                              <div style={{ marginLeft: "20px" }}>
                                                <button
                                                  type="button"
                                                  className="btn btn-danger me-2"
                                                  onClick={handleRemoveImg}
                                                >
                                                  Remove
                                                </button>
                                              </div>
                                              : <></>}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="col-4">
                                    <div className="form-group">
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name="feature"
                                          checked={product.feature}
                                          onChange={handleInputChange}
                                        />
                                        <label className="form-check-label">
                                          Feature
                                        </label>
                                      </div>
                                    </div>
                                  </div> */}
                                </div>

                                <button
                                  type="submit"
                                  className="btn btn-primary me-2"
                                  onClick={handleSaveProduct}
                                >
                                  Submit
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-primary me-2"
                                  onClick={handleManageVariantClick}
                                >
                                  Manage Variant(s)
                                </button>
                                <button
                                  className="btn btn btn-secondary"
                                  onClick={handleDishesProductsClick}
                                >
                                  Cancel
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LoadingModal isLoading={isLoading} />
          <Notification />
        </>
      )}
    </>
  );
};

export default EditProduct;